import { Component, Input } from '@angular/core';
import { CompagnieEntite } from '../entites/compagnie';
import { DonneesBaseService } from '../services/donnees-base-service';

/**
 * Affiche le nom d'une compagnie avec son logo, hydraté depuis la liste
 * préchargée (les payloads d'items n'incluent pas l'image).
 */
@Component({
    selector: 'app-compagnie-label',
    template: `
        @if (nom) {
            <span class="inline-flex align-items-center gap-1">
                @if (image) {
                    <img [src]="image" alt="" class="compagnie-label-image" />
                }
                <span>{{ nom }}</span>
            </span>
        }
    `,
    styles: [`
        :host {
            display: inline-flex;
            align-items: center;
        }
        .compagnie-label-image {
            width: 1rem;
            height: 1rem;
            object-fit: contain;
            flex-shrink: 0;
        }
    `]
})
export class CompagnieLabelComponent {
    @Input() compagnie?: CompagnieEntite | null;

    constructor(private sdb: DonneesBaseService) {}

    get nom(): string {
        return this.compagnie?.nom?.trim() ?? '';
    }

    get image(): string | undefined {
        const liste = this.sdb.Compagnies();
        const id = this.compagnie?.compagnieId;
        const preloaded = id != null && liste ? this.sdb.Compagnie(id) : undefined;
        const parNom = this.nom && liste ? liste.find(c => c.nom === this.nom) : undefined;
        const src = (preloaded?.image || parNom?.image || this.compagnie?.image || '').trim();
        return src || undefined;
    }
}
